
// export interface ErrorInterface {

//     title?: string;
//     message: string;
//     code?: number;

// }

export const getMessageFromError = (error, values) => { //ErrorInterface

    let title = values?.title || 'Error';
    let message = values?.message || 'Error';
    let code = values?.code || 0;

    if (error.response) {

        if (error.response.data) {

            if (error.response.data.message) {
                message = error.response.data.message;
            } else {
                message = error.response.data.includes('html') ? error.message : error.response.data;
            }

        }

    } else if (error.message) {
        message = error.message;
    }

    return {
        title,
        message,
        code
    }

}
